<template>
  <div>
    <y-periodselector @period="periodselected" :iscierre="false" :period="period"></y-periodselector>
    <div class="columns">
      <div class="column is-2">
        <h1 class="title">Iva</h1>
      </div>
      <div class="column is-3">
        <div class="field has-addons">
          <p class="control">
            <button class="button" :class="periodicidad.isbimestral ? 'is-primary' : ''"
              @click="selectperidicidad('isbimestral')">
              <span>Bimestral</span>
            </button>
          </p>
          <p class="control">
            <button class="button" :class="periodicidad.iscuatrimestral ? 'is-primary' : ''"
              @click="selectperidicidad('iscuatrimestral')">
              <span>Cuatrimestral</span>
            </button>
          </p>
        </div>
      </div>
      <div class="column">
        <button class="button is-link" @click="search">Buscar</button>
      </div>
    </div>
    <table>
      <tr>
        <th>Ingresos Operativos</th>
        <th v-for="(item, index) in summary.meses" :key="index" class="has-text-centered">
          {{ nmeses[item] }}
        </th>
        <th class="has-text-centered">Total</th>
      </tr>
      <tbody v-for="(item, index) in summary.ingresos.operativos.list" :key="index">
        <tr v-for="(item2, index2) in summary.ingresos.operativos[item].list" :key="index2">
          <td class="fontMono">
            {{ summary.ingresos.operativos[item][item2].codigocuenta }}
            <span style="font-size: 12px" class="has-text-grey">{{
                summary.ingresos.operativos[item][item2].nombrecuenta
            }}</span>
          </td>
          <td v-for="(item3, index3) in summary.meses" :key="index3" class="fontMono has-text-right">
            {{ summary.ingresos.operativos[item][item2][item3] | number() }}
          </td>
          <td class="fontMono has-text-right">
            {{ summary.ingresos.operativos[item][item2]["total"] | number }}
          </td>
        </tr>
        <tr>
          <th class="fontMono">
            {{ summary.ingresos.operativos[item].codigocomprobante }}
            <span style="font-size: 14px" class="has-text-grey">
              {{ summary.ingresos.operativos[item].nombrecomprobane }}
            </span>
          </th>
          <th v-for="(item1, index1) in summary.meses" :key="index1" class="fontMono has-text-right">
            {{ summary.ingresos.operativos[item][item1] | number }}
          </th>
          <th class="fontMono has-text-right">
            {{ summary.ingresos.operativos[item]["total"] | number }}
          </th>
        </tr>
      </tbody>
      <tr>
        <th class="oscuro">Total Ingresos Operativos</th>
        <th v-for="(item, index) in summary.meses" :key="index" class="has-text-right fontMono oscuro">
          {{ summary.ingresos.operativos["total"][item] | number() }}
        </th>
        <th class="has-text-right fontMono oscuro">
          {{ summary.ingresos.operativos["total"]["total"] | number() }}
        </th>
      </tr>
      <tr>
        <td :colspan="summary.meses.length + 2" style="color: white">.</td>
      </tr>
      <tr>
        <th>Ingresos no Operativos</th>
        <th v-for="(item, index) in summary.meses" :key="index" class="has-text-centered">
          {{ nmeses[item] }}
        </th>
        <th class="has-text-centered">Total</th>
      </tr>
      <tbody v-for="(item, index) in summary.ingresos.otros.list" :key="'n' + index">
        <tr v-for="(item2, index2) in summary.ingresos.otros[item].list" :key="'na' + index2">
          <td class="fontMono">
            {{ summary.ingresos.otros[item][item2].codigocuenta }}
            <span style="font-size: 12px" class="has-text-grey">{{
                summary.ingresos.otros[item][item2].nombrecuenta
            }}</span>
          </td>
          <td v-for="(item3, index3) in summary.meses" :key="'nb' + index3" class="fontMono has-text-right">
            {{ summary.ingresos.otros[item][item2][item3] | number() }}
          </td>
          <td class="fontMono has-text-right">
            {{ summary.ingresos.otros[item][item2]["total"] | number }}
          </td>
        </tr>
        <tr>
          <th class="fontMono">
            {{ summary.ingresos.otros[item].codigocomprobante }}
            <span style="font-size: 14px" class="has-text-grey">
              {{ summary.ingresos.otros[item].nombrecomprobane }}
            </span>
          </th>
          <th v-for="(item1, index1) in summary.meses" :key="'nc' + index1" class="fontMono has-text-right">
            {{ summary.ingresos.otros[item][item1] | number }}
          </th>
          <th class="fontMono has-text-right">
            {{ summary.ingresos.otros[item]["total"] | number }}
          </th>
        </tr>
      </tbody>
      <tr>
        <th class="oscuro">Total Ingresos no Operativos</th>
        <th v-for="(item, index) in summary.meses" :key="index" class="has-text-right fontMono oscuro">
          {{ summary.ingresos.otros["total"][item] | number() }}
        </th>
        <th class="has-text-right fontMono oscuro">
          {{ summary.ingresos.otros["total"]["total"] | number() }}
        </th>
      </tr>
      <tr>
        <td :colspan="summary.meses.length + 2" style="color: white">.</td>
      </tr>
      <tr>
        <th>Iva</th>
        <th v-for="(item, index) in summary.meses" :key="'ig' + index" class="has-text-centered">
          {{ nmeses[item] }}
        </th>
        <th class="has-text-centered">Total</th>
      </tr>
      <tbody v-for="(item, index) in summary.iva.generado.list" :key="'iga' + index">
        <tr v-for="(item2, index2) in summary.iva.generado[item].list" :key="index2">
          <td class="fontMono">
            {{ summary.iva.generado[item][item2].codigocuenta }}
            <span style="font-size: 12px" class="has-text-grey">{{
                summary.iva.generado[item][item2].nombrecuenta
            }}</span>
          </td>
          <td v-for="(item3, index3) in summary.meses" :key="'igb' + index3" class="fontMono has-text-right">
            {{ summary.iva.generado[item][item2][item3] | number() }}
          </td>
          <td class="fontMono has-text-right">
            {{ summary.iva.generado[item][item2]["total"] | number }}
          </td>
        </tr>
        <tr>
          <th class="fontMono">
            {{ summary.iva.generado[item].codigocomprobante }}
            <span style="font-size: 14px" class="has-text-grey">
              {{ summary.iva.generado[item].nombrecomprobane }}
            </span>
          </th>
          <th v-for="(item1, index1) in summary.meses" :key="'igc' + index1" class="fontMono has-text-right">
            {{ summary.iva.generado[item][item1] | number }}
          </th>
          <th class="fontMono has-text-right">
            {{ summary.iva.generado[item]["total"] | number }}
          </th>
        </tr>
      </tbody>
      <tr>
        <th class="oscuro">Total Iva</th>
        <th v-for="(item, index) in summary.meses" :key="'igd' + index" class="has-text-right fontMono oscuro">
          {{ summary.iva.generado["total"][item] | number() }}
        </th>
        <th class="has-text-right fontMono oscuro">
          {{ summary.iva.generado["total"]["total"] | number() }}
        </th>
      </tr>
    </table>
  </div>
</template>

<script>
// TODO Que pueda seleccionar las cuentas de iva y se deben grabar en paramsreports. En este momento toma las que empiezan por 2408 pero la idea es que el usuario pueda elegir las que quiera
// Ademas el otro punto que falta es que pueda seleccionar de esas cuentas, cuales son iva generado y cual es iva descontable de esa forma en la tabla se separarian entre esas dos en la tabla. 
// Es decir que en la tabla hay que crear otra seccion que se llame iva descontable.
// Por ultimo que se llene el formulario de iva. seleccionando en cada cuenta el renglon del formulario en el que se acumulara.
// el formulario iria en la parte de abajo de la tabla`
import yPeriodselector from "@/components/commons/Periodselector.vue";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      nmeses: {
        1: "Ene",
        2: "Feb",
        3: "Mzo",
        4: "Abr",
        5: "Myo",
        6: "Jun",
        7: "Jul",
        8: "Ago",
        9: "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dic",
      },
      summary: {
        meses: [],
        ingresos: {
          operativos: {
            list: [],
            total: {
              idcomprobante: "total",
              codigocomprobante: "Total",
              nombrecomprobane: "",
              idcuenta: "total",
              codigocuenta: "Total",
              nombrecuenta: "",
              total: 0,
            },
          },
          otros: {
            list: [],
            total: {
              idcomprobante: "total",
              codigocomprobante: "Total",
              nombrecomprobane: "",
              idcuenta: "total",
              codigocuenta: "Total",
              nombrecuenta: "",
              total: 0,
            },
          },
        },
        iva: {
          generado: {
            list: [],
            total: {
              idcomprobante: "total",
              codigocomprobante: "Total",
              nombrecomprobane: "",
              idcuenta: "total",
              codigocuenta: "Total",
              nombrecuenta: "",
              total: 0,
            },
          },
          descontable: {
            list: [],
            total: {
              idcomprobante: "total",
              codigocomprobante: "Total",
              nombrecomprobane: "",
              idcuenta: "total",
              codigocuenta: "Total",
              nombrecuenta: "",
              total: 0,
            },
          }
        }
      },
      period: {
        year: null,
        months: null,
      },
      periodicidad: {
        isbimestral: true,
        iscuatrimestral: false,
      },
      paramsreports: {},
    };
  },
  methods: {
    selectperidicidad(periodicidad) {
      if (periodicidad === "isbimestral") {
        this.periodicidad.isbimestral = true;
        this.periodicidad.iscuatrimestral = false;
      } else {
        this.periodicidad.isbimestral = false;
        this.periodicidad.iscuatrimestral = true;
      }
    },
    periodselected(period) {
      this.period = period;
    },
    transformdata(d) {
      const returned = {
        meses: [],
        ingresos: {
          operativos: {
            list: [],
            total: {
              idcomprobante: "total",
              codigocomprobante: "Total",
              nombrecomprobane: "",
              idcuenta: "total",
              codigocuenta: "Total",
              nombrecuenta: "",
              total: 0,
            },
          },
          otros: {
            list: [],
            total: {
              idcomprobante: "total",
              codigocomprobante: "Total",
              nombrecomprobane: "",
              idcuenta: "total",
              codigocuenta: "Total",
              nombrecuenta: "",
              total: 0,
            },
          },
        },
        iva: {
          generado: {
            list: [],
            total: {
              idcomprobante: "total",
              codigocomprobante: "Total",
              nombrecomprobane: "",
              idcuenta: "total",
              codigocuenta: "Total",
              nombrecuenta: "",
              total: 0,
            },
          },
          descontable: {
            list: [],
            total: {
              idcomprobante: "total",
              codigocomprobante: "Total",
              nombrecomprobane: "",
              idcuenta: "total",
              codigocuenta: "Total",
              nombrecuenta: "",
              total: 0,
            },
          }
        }
      };
      const meses = [];
      const mes = parseInt(this.period.months[0]);
      if (this.periodicidad.isbimestral) {
        meses.push(mes - 1);
        meses.push(mes);
        returned.ingresos.operativos.total[mes - 1] = 0;
        returned.ingresos.operativos.total[mes] = 0;
        returned.ingresos.otros.total[mes - 1] = 0;
        returned.ingresos.otros.total[mes] = 0;
        returned.iva.generado.total[mes - 1] = 0;
        returned.iva.generado.total[mes] = 0;
      } else {
        meses.push(mes - 3);
        meses.push(mes - 2);
        meses.push(mes - 1);
        meses.push(mes);
        returned.ingresos.operativos.total[mes - 3] = 0;
        returned.ingresos.operativos.total[mes - 2] = 0;
        returned.ingresos.operativos.total[mes - 1] = 0;
        returned.ingresos.operativos.total[mes] = 0;
        returned.ingresos.otros.total[mes - 3] = 0;
        returned.ingresos.otros.total[mes - 2] = 0;
        returned.ingresos.otros.total[mes - 1] = 0;
        returned.ingresos.otros.total[mes] = 0;
        returned.iva.generado.total[mes - 3] = 0;
        returned.iva.generado.total[mes - 2] = 0;
        returned.iva.generado.total[mes - 1] = 0;
        returned.iva.generado.total[mes] = 0;
      }
      returned.meses = meses;

      const objectCuentaIngresos = {};
      const objectCuentaIvas = {};
      const objectComprobantes = {};
      for (let index in d.cuentaingresos) {
        const n = d.cuentaingresos[index];
        objectCuentaIngresos[n._id] = n;
      }
      for (let index in d.cuentasIvas) {
        const n = d.cuentasIvas[index];
        objectCuentaIvas[n._id] = n;
      }
      for (let index in d.comprobantes) {
        const n = d.comprobantes[index];
        objectComprobantes[n._id] = n;
      }
      for (let index in d.ingresos) {
        const n = d.ingresos[index];
        const datacuenta = objectCuentaIngresos[n._id.idcuenta];
        const datacomprobante = objectComprobantes[n._id.comprobanteid];
        if (parseInt(datacuenta.codigo.substr(0, 2)) === 41) {
          if (
            returned.ingresos.operativos.list.indexOf(n._id.comprobanteid) ===
            -1
          ) {
            returned.ingresos.operativos.list.push(n._id.comprobanteid);
            returned.ingresos.operativos[n._id.comprobanteid] = {
              idcomprobante: n._id.comprobanteid,
              codigocomprobante: datacomprobante.codigo,
              nombrecomprobane: datacomprobante.nombre,
              total: 0,
              list: [],
            };
            for (let index1 in meses) {
              const m = meses[index1];
              returned.ingresos.operativos[n._id.comprobanteid][m] = 0;
            }
          }
          if (
            returned.ingresos.operativos[n._id.comprobanteid].list.indexOf(
              n._id.idcuenta
            ) === -1
          ) {
            returned.ingresos.operativos[n._id.comprobanteid].list.push(
              n._id.idcuenta
            );
            returned.ingresos.operativos[n._id.comprobanteid][n._id.idcuenta] =
            {
              idcuenta: n._id.idcuenta,
              codigocuenta: datacuenta.codigo,
              nombrecuenta: datacuenta.nombre,
              idcomprobante: n._id.comprobanteid,
              codigocomprobante: datacomprobante.codigo,
              nombrecomprobane: datacomprobante.nombre,
              total: 0,
            };
            for (let index1 in meses) {
              const m = meses[index1];
              returned.ingresos.operativos[n._id.comprobanteid][n._id.idcuenta][
                m
              ] = 0;
            }
          }
          returned.ingresos.operativos[n._id.comprobanteid][n._id.idcuenta][
            n._id.mes
          ] += n.valor;
          returned.ingresos.operativos[n._id.comprobanteid][n._id.mes] +=
            n.valor;
          returned.ingresos.operativos["total"][n._id.mes] += n.valor;
          returned.ingresos.operativos[n._id.comprobanteid]["total"] += n.valor;
          returned.ingresos.operativos["total"]["total"] += n.valor;
          returned.ingresos.operativos[n._id.comprobanteid][n._id.idcuenta][
            "total"
          ] += n.valor;
        } else {
          if (
            returned.ingresos.otros.list.indexOf(n._id.comprobanteid) === -1
          ) {
            returned.ingresos.otros.list.push(n._id.comprobanteid);
            returned.ingresos.otros[n._id.comprobanteid] = {
              idcomprobante: n._id.comprobanteid,
              codigocomprobante: datacomprobante.codigo,
              nombrecomprobane: datacomprobante.nombre,
              total: 0,
              list: [],
            };
            for (let index1 in meses) {
              const m = meses[index1];
              returned.ingresos.otros[n._id.comprobanteid][m] = 0;
            }
          }
          if (
            returned.ingresos.otros[n._id.comprobanteid].list.indexOf(
              n._id.idcuenta
            ) === -1
          ) {
            returned.ingresos.otros[n._id.comprobanteid].list.push(
              n._id.idcuenta
            );
            returned.ingresos.otros[n._id.comprobanteid][n._id.idcuenta] = {
              idcuenta: n._id.idcuenta,
              codigocuenta: datacuenta.codigo,
              nombrecuenta: datacuenta.nombre,
              idcomprobante: n._id.comprobanteid,
              codigocomprobante: datacomprobante.codigo,
              nombrecomprobane: datacomprobante.nombre,
              total: 0,
            };
            for (let index1 in meses) {
              const m = meses[index1];
              returned.ingresos.otros[n._id.comprobanteid][n._id.idcuenta][
                m
              ] = 0;
            }
          }
          returned.ingresos.otros[n._id.comprobanteid][n._id.idcuenta][
            n._id.mes
          ] += n.valor;
          returned.ingresos.otros[n._id.comprobanteid][n._id.mes] += n.valor;
          returned.ingresos.otros["total"][n._id.mes] += n.valor;
          returned.ingresos.otros[n._id.comprobanteid]["total"] += n.valor;
          returned.ingresos.otros["total"]["total"] += n.valor;
          returned.ingresos.otros[n._id.comprobanteid][n._id.idcuenta][
            "total"
          ] += n.valor;
        }
      }
      returned.ingresos.operativos.list.sort(function (a, b) {
        if (objectComprobantes[a].codigo < objectComprobantes[b].codigo) {
          return -1;
        }
        if (objectComprobantes[a].codigo > objectComprobantes[b].codigo) {
          return 1;
        }
        return 0;
      });
      returned.ingresos.otros.list.sort(function (a, b) {
        if (objectComprobantes[a].codigo < objectComprobantes[b].codigo) {
          return -1;
        }
        if (objectComprobantes[a].codigo > objectComprobantes[b].codigo) {
          return 1;
        }
        return 0;
      });
      for (let index in returned.ingresos.operativos.list) {
        const comprobante = returned.ingresos.operativos.list[index];
        returned.ingresos.operativos[comprobante].list.sort(function (a, b) {
          if (objectCuentaIngresos[a].codigo < objectCuentaIngresos[b].codigo) {
            return -1;
          }
          if (objectCuentaIngresos[a].codigo > objectCuentaIngresos[b].codigo) {
            return 1;
          }
          return 0;
        });
      }
      for (let index in returned.ingresos.otros.list) {
        const comprobante = returned.ingresos.otros.list[index];
        returned.ingresos.otros[comprobante].list.sort(function (a, b) {
          if (objectCuentaIngresos[a].codigo < objectCuentaIngresos[b].codigo) {
            return -1;
          }
          if (objectCuentaIngresos[a].codigo > objectCuentaIngresos[b].codigo) {
            return 1;
          }
          return 0;
        });
      }
      for (let index in d.iva) {
        const n = d.iva[index];
        const datacuentaIva = objectCuentaIvas[n._id.idcuenta];
        const datacomprobante = objectComprobantes[n._id.comprobanteid];
        if (this.paramsreports.params[n._id.idcuenta].categoria === "generado") {
          if (
            returned.iva.generado.list.indexOf(n._id.comprobanteid) ===
            -1
          ) {
            returned.iva.generado.list.push(n._id.comprobanteid);
            returned.iva.generado[n._id.comprobanteid] = {
              idcomprobante: n._id.comprobanteid,
              codigocomprobante: datacomprobante.codigo,
              nombrecomprobane: datacomprobante.nombre,
              total: 0,
              list: [],
            };
            for (let index1 in meses) {
              const m = meses[index1];
              returned.iva.generado[n._id.comprobanteid][m] = 0;
            }
          }
          if (
            returned.iva.generado[n._id.comprobanteid].list.indexOf(
              n._id.idcuenta
            ) === -1
          ) {
            returned.iva.generado[n._id.comprobanteid].list.push(
              n._id.idcuenta
            );
            returned.iva.generado[n._id.comprobanteid][n._id.idcuenta] =
            {
              idcuenta: n._id.idcuenta,
              codigocuenta: datacuentaIva.codigo,
              nombrecuenta: datacuentaIva.nombre,
              idcomprobante: n._id.comprobanteid,
              codigocomprobante: datacomprobante.codigo,
              nombrecomprobane: datacomprobante.nombre,
              total: 0,
            };
            for (let index1 in meses) {
              const m = meses[index1];
              returned.iva.generado[n._id.comprobanteid][n._id.idcuenta][
                m
              ] = 0;
            }
          }
          returned.iva.generado[n._id.comprobanteid][n._id.idcuenta][
            n._id.mes
          ] += n.valor;
          returned.iva.generado[n._id.comprobanteid][n._id.mes] +=
            n.valor;
          returned.iva.generado["total"][n._id.mes] += n.valor;
          returned.iva.generado[n._id.comprobanteid]["total"] += n.valor;
          returned.iva.generado["total"]["total"] += n.valor;
          returned.iva.generado[n._id.comprobanteid][n._id.idcuenta][
            "total"
          ] += n.valor;

        }
      }
      returned.iva.generado.list.sort(function (a, b) {
        if (objectComprobantes[a].codigo < objectComprobantes[b].codigo) {
          return -1;
        }
        if (objectComprobantes[a].codigo > objectComprobantes[b].codigo) {
          return 1;
        }
        return 0;
      });
      for (let index in returned.iva.generado.list) {
        const comprobante = returned.iva.generado.list[index];
        returned.iva.generado[comprobante].list.sort(function (a, b) {
          if (objectCuentaIvas[a].codigo < objectCuentaIvas[b].codigo) {
            return -1;
          }
          if (objectCuentaIvas[a].codigo > objectCuentaIvas[b].codigo) {
            return 1;
          }
          return 0;
        });
      }
      return returned;
    },
    async search() {
      try {
        const query = {
          period: this.period,
          periodicidad: this.periodicidad,
          params: this.paramsreports,
        };
        const result = await apiServices.post(`/ivasummary`, query);
        if (result.data) {
          this.summary = this.transformdata(result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findParamReport() {
      try {
        const result = await apiServices.get(`/paramsreports/cuentasiva`);
        if (result.data) {
          this.paramsreports = result.data;
        } else {
          const result1 = await apiServices.get(`/cuentasiva`);
          if (result1.data) {
            const params = {
              list: [],
            };
            for (let index in result1.data) {
              const c = result1.data[index];
              params.list.push(c._id);
              params[c._id] = {
                id: c._id,
                categoria: "generado",
              };
            }
            const result2 = await apiServices.post(`/paramsreports`, {
              params,
              codigo: "cuentasiva",
            });
            if (result2.data) {
              this.paramsreports = result2.data;
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.findParamReport();
    const today = new Date();
    this.period.year = today.getFullYear();
    this.period.months = [today.getMonth() + 1];
  },
  components: {
    yPeriodselector,
  },
};
</script>

<style lang="scss" scoped>
td {
  padding: 1px 5px 1px 5px;
  border: 1px solid #dbdbdb;
}

th {
  padding: 1px 5px 1px 5px;
  border: 1px solid #dbdbdb;
  background-color: whitesmoke;
}

.oscuro {
  background-color: grey;
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/iva/Iva.vue